<div class="catalog-article-search">
  <form [formGroup]="formGroup">
    <sc-flex>

      <mat-form-field appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="erp.ui.articlesearch.query"></sc-dictionary-label>
        </mat-label>
        <input matInput formControlName="query">
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-checkbox name="includeArchivedArticles" formControlName="includeArchivedArticles">
        <sc-dictionary-label dictionaryKey="erp.ui.articlesearch.include-archived-articles"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button (click)="refreshArticleList()">
        <mat-icon><sc-icon iconClass="fa-refresh"></sc-icon></mat-icon>
        <sc-dictionary-label dictionaryKey="erp.ui.articlesearch.action.search"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button (click)="exportArticleList()" [disabled]="!downloadEnabled">
        <mat-icon><sc-icon iconClass="fa-download"></sc-icon></mat-icon>
        <sc-dictionary-label dictionaryKey="erp.ui.articlesearch.action.export-articles"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button (click)="importCostsPrices()">
        <mat-icon><sc-icon iconClass="fa-upload"></sc-icon></mat-icon>
        <sc-dictionary-label dictionaryKey="erp.ui.catalog.action.import-costsprices"></sc-dictionary-label>
      </button>
    </sc-flex>

  </form>
  <sc-content-spacer vertical></sc-content-spacer>
  <div>
      <sc-scroll-pane>
          <ng-container *ngFor="let item of items; let i = index">
              <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>
              <sc-bordered-tile>
                  <sc-padding class="text-selection">
                    <sc-flex >
                      <div>
                        {{item.identifier}}
                        <ng-container *ngIf="item.archived">&nbsp;({{ '(Archiviert)' | translate: ['erp.entity.article.archived', translationService.language]}})</ng-container>
                      </div>
                      <sc-content-spacer [double]="true"></sc-content-spacer>
                      <div>{{item.retailPriceDaily?.priceNet | numberFormat:priceScale}}</div>
                      <sc-content-spacer [double]="true"></sc-content-spacer>
                      <button mat-icon-button (click)="editArticle(item)">
                          <sc-icon iconClass="fa-pencil"></sc-icon>
                      </button>
                    </sc-flex>
                  </sc-padding>
              </sc-bordered-tile>
          </ng-container>
      </sc-scroll-pane>
  </div>

</div>
